import React from 'react'
import { Modal, Box, Text } from '@deseretbook/react-ui'

/**
 * Loading view of the subscription signup moal.
 *
 * @returns {function} Component
 */
const LoadingView = () => (
  <Modal.Content>
    <Box isFullwidth isFullheight alignItems="center" justifyContent="center">
      <Text hasEllipsis size="large">Loading...</Text>
    </Box>
  </Modal.Content>
)

export default LoadingView
